import {observer} from 'mobx-react';
import InterviewDetails from './InterviewDetails';
import Interviewers from './Interviewers';
import Availability from './Availability';
import InvitationEmail from './InvitationEmail';
import Review from './Review';

const Step = observer(({step, uiState}) => {
  switch (step) {
    case 'interview_details':
      return <InterviewDetails uiState={uiState}/>;
    case 'interviewers':
      return <Interviewers uiState={uiState}/>;
    case 'availability':
      return <Availability uiState={uiState}/>;
    case 'invitation_email':
      return <InvitationEmail uiState={uiState}/>;
    case 'review':
      return <Review uiState={uiState}/>;
    default:
      throw new Error(`Location ${step} is not supported.`);
  }
});

export default Step;
